import { render, staticRenderFns } from "./pages-list.vue?vue&type=template&id=ba55b780"
import script from "./pages-list.vue?vue&type=script&lang=js"
export * from "./pages-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports